import 'rtc-firebase-lib';

const requiredEnvKeys = [
  'VUE_APP_FIREBASE_REPORT_TOKEN_URL',
  "VUE_APP_FIREBASE_API_KEY",
  'VUE_APP_FIREBASE_APP_ID',
  'VUE_APP_FIREBASE_PROJECT_ID',
  'VUE_APP_FIREBASE_SENDER_ID',
  'VUE_APP_FIREBASE_MEASUREMENT_ID',
  'VUE_APP_FIREBASE_SW_URL',
  'VUE_APP_FIREBASE_SW_SCOPE',
];

if(requiredEnvKeys.every(key => Boolean(process.env[key])))
  window.firebase({
    config: {
      reportTokenUrl: process.env.VUE_APP_FIREBASE_REPORT_TOKEN_URL,
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      appId: process.env.VUE_APP_FIREBASE_APP_ID,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      senderId: process.env.VUE_APP_FIREBASE_SENDER_ID,
      measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
      swUrl: process.env.VUE_APP_FIREBASE_SW_URL,
      swScope: process.env.VUE_APP_FIREBASE_SW_SCOPE,
    },

    notificationModal: {
      message: 'Todo sobre préstamos, créditos hipotecarios y compra de deuda hipotecaria a tu alcance y al instante ¡Únete!',
      timeout: Number(process.env.VUE_APP_FIREBASE_TIMEOUT) || 15000,
    },
  });
